module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-12-f2e9f5636eb08a491a819dda5dfa8430.png";